export const commonEs = {
  // Header
  'header.search': 'Buscar productos...',
  'header.cart': 'Carrito',
  'header.login': 'Iniciar sesión',
  'header.admin': 'Panel Admin',
  'header.distributor': 'Panel Distribuidor',
  'header.logout': 'Cerrar sesión',
  
  // Navigation
  'nav.home': 'Inicio',
  'nav.windows': 'Windows',
  'nav.office': 'Office',
  'nav.antivirus': 'Antivirus',
  'nav.vpn': 'VPN',
  'nav.testimonials': 'Testimonios',
  'nav.distributor': 'Distribuidores',
  'nav.legal': 'Legal',
  
  // Hero Slides
  'hero.vpn.title': 'VPN - PROTECCIÓN Y PRIVACIDAD TOTAL',
  'hero.vpn.subtitle': 'HASTA 77% DE DESCUENTO',
  'hero.vpn.description': 'Navega seguro y anónimo con las mejores VPN del mercado',
  'hero.vpn.button': 'Ver ofertas VPN',
  'hero.vpn.badge': 'OFERTA -77%',
  
  'hero.windows.title': 'LICENCIAS WINDOWS 11',
  'hero.windows.subtitle': 'Desde $65.963',
  'hero.windows.description': 'Actualiza tu sistema operativo con las mejores ofertas',
  'hero.windows.button': 'Comprar ahora',
  
  'hero.office.title': 'MICROSOFT OFFICE 365',
  'hero.office.subtitle': 'MÁS DE 60% DE DESCUENTO',
  'hero.office.description': 'Productividad profesional al mejor precio',
  'hero.office.button': 'Ver ofertas',
  'hero.office.badge': 'OFERTA +60%',
  
  // Search
  'search.results': 'Resultados para:',
  'search.clear': 'Limpiar',
  'search.noResults': 'No se encontraron productos',
  'search.noResultsDesc': 'No hay productos que coincidan con tu búsqueda',
  'search.viewAll': 'Ver todos los productos',
  
  // Product Sections
  'section.windows': 'Licencias Windows',
  'section.office': 'Licencias Microsoft Office',
  'section.officeLtsc': 'Licencias Office 365 LTSC',
  'section.antivirus': 'Antivirus',
  'section.vpn': 'VPN - Redes Privadas Virtuales',
  
  // Product Details
  'product.lifetime': 'Licencia de por vida',
  'product.rating': '(5.0)',
  'product.sold': 'vendidos',
  'product.badge': 'Oferta',
  'product.monthly': 'Mensuales',
  'product.multiAccount': 'Con 5 cuentas, licencia de por vida con un descuento del 20%',
  
  // CTA Section
  'cta.title': '¿TIENDA DE INFORMÁTICA O RESELLER?',
  'cta.description': '¿Eres una tienda de informática o un revendedor de software? Únete a nuestro programa de distribuidores y disfruta de precios especiales y condiciones exclusivas.',
  'cta.button': 'Conviértete en Distribuidor',
  'cta.specialPrices': 'Precios Especiales',
  'cta.exclusiveConditions': 'Condiciones Exclusivas',
  'cta.prioritySupport': 'Soporte Prioritario',
  
  // Info Boxes
  'info.lowPrices.title': 'Precios más bajos',
  'info.lowPrices.desc': 'Ofrecemos los mejores precios del mercado en licencias de software originales. Ahorra hasta un 70% en tus compras.',
  'info.fastDelivery.title': 'Envíos rápidos',
  'info.fastDelivery.desc': 'Recibe tu licencia al instante por correo electrónico. Sin esperas, sin complicaciones. Activación inmediata.',
  'info.guarantee.title': 'Tranquilidad garantizada',
  'info.guarantee.desc': 'Soporte técnico 24/7 y garantía de por vida en todas nuestras licencias perpetuas. Tu satisfacción es nuestra prioridad.',
  
  // Footer
  'footer.description': 'Tu tienda de confianza para licencias de software originales. Precios competitivos y entrega inmediata.',
  'footer.products': 'Productos',
  'footer.company': 'Empresa',
  'footer.support': 'Soporte',
  'footer.contact': 'Contacto',
  'footer.aboutUs': 'Sobre nosotros',
  'footer.terms': 'Términos y condiciones',
  'footer.privacy': 'Política de privacidad',
  'footer.faq': 'Preguntas frecuentes',
  'footer.help': 'Centro de ayuda',
  'footer.rights': 'Todos los derechos reservados.',
  'footer.poweredBy': 'Creado con',
  
  // Payment Methods
  'payment.methods': 'Métodos de pago disponibles',
  'payment.nequi': 'Nequi',
  'payment.daviplata': 'Daviplata',
  'payment.bancolombia': 'Bancolombia',
  'payment.efecty': 'Efecty',
  'payment.card': 'Tarjeta',
  'payment.paypal': 'PayPal',
  'payment.buyNow': 'Comprar ahora',
  
  // Common
  'common.loading': 'Cargando...',
  'common.error': 'Error',
  'common.success': 'Éxito',
  'common.cancel': 'Cancelar',
  'common.confirm': 'Confirmar',
  'common.save': 'Guardar',
  'common.delete': 'Eliminar',
  'common.edit': 'Editar',
  'common.view': 'Ver',
  'common.close': 'Cerrar',
};

export default commonEs;
